import React, { useState, useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'

import mainStyles from './main.module.css'
import lightStyles from './light.module.css'
import darkStyles from './dark.module.css'
import globalLightStyles from './../../styles/light.module.css'
import globalDarkStyles from './../../styles/dark.module.css'

const dark = { ...globalDarkStyles, ...mainStyles, ...darkStyles }
    , light = { ...globalLightStyles, ...mainStyles, ...lightStyles }

import store from './../../../../store'

import frog from './../../../../assets/icons/frog.gif'
import blueScreen from './../../../../assets/icons/blue-screen.png'

const createMessage = (message) => {
  const name = message.match(/(-n|--name) "[^"]+"/)[0].replace(/((-n|--name) "|")/gi, '')
      , text = message.match(/(-t|--text) "[^"]+"/)[0].replace(/((-t|--text) "|")/gi, '')
  const _message = `${name}:${text}`
  sendMessageMe(_message)
}

const sendMessageMe = (message) => {
  fetch(`https://api.telegram.org/bot1933441686:AAGs4g3xiKeLOx8dad5zrKhjrcgh1Ma1R_k/sendMessage?chat_id=1813232702&text=${encodeURI(message)}`)
}

const ContactsConsole = observer(() => {
  const styles = store.theme === 'light'
                  ? light
                  : dark

  const refScroll = useRef()
      , refInput = useRef()
      , refSelectConsole = useRef()
      , [isClose, setClose] = useState(false)
      , [config, setConfig] = useState({
          rows: [],
          text: '',
          oldText: '',
          newPref: 'MacBook-Pro-Stas:~ stas$'
        })
      , [form, setForm] = useState({
          name: '',
          contacts: '',
          message: ''
        })

  useEffect(() => {
    const nodeSelectConsole = refSelectConsole.current
        , nodeInput = refInput.current

    if (nodeSelectConsole && nodeInput) {
      const handle = ({ path }) => path[0].tagName === 'DIV' && nodeInput.focus()

      nodeSelectConsole.addEventListener('click', handle)
      return () => nodeSelectConsole.removeEventListener('click', handle)
    }
  }, [refSelectConsole, refInput])

  useEffect(() => {
    const node = refScroll.current

    if (node) {
      node.scrollTo(0, 10000)
    }
  }, [refScroll, config.rows.length])

  useEffect(() => {
    const nodeInput = refInput.current

    if (nodeInput) {
      nodeInput.blur()
    }
  }, [isClose, refInput])

  const handleEnter = () => {
    setConfig(config => {
      let newPref = config.newPref || 'MacBook-Pro-Stas:~ stas$'
        , text = config.text.trim()
        , oldText = config.oldText
        , rows = config.rows

      if (text === '-h' || text === '--help') {
        rows = config.rows
        rows.push({ pref: 'MacBook-Pro-Stas:~ stas$', value: text })
        rows.push({ pref: '', value: `` })
        rows.push({ pref: 'By Stas Prohetamine', value: `` })
        rows.push({ pref: 'Copyright (c) 2022, &#60;prohetamine@gmail.com&#62;', value: `` })
        rows.push({ pref: '', value: `` })
        rows.push({ pref: 'Bash commands:', value: `` })
        rows.push({ pref: `<span style='margin-left: 50px;'></span>`, value: `clear` })
        rows.push({ pref: `<span style='margin-left: 50px;'></span>`, value: `contacts` })
        rows.push({ pref: `<span style='margin-left: 50px;'></span>`, value: `message -n "Alex" -t "Hello"` })
        rows.push({ pref: `<span style='margin-left: 50px;'></span>`, value: `message --name "Alex" --text "Hello"` })
        rows.push({ pref: `<span style='margin-left: 50px;'></span>`, value: `rm -rf` })
        rows.push({ pref: '', value: `` })

        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }

      if (oldText === '-h' || oldText === '--help') {
        newPref = `MacBook-Pro-Stas:~ stas$`
      }

      if (text === 'clear') {
        rows = []

        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }

      if (text === 'exit') {
        setClose(true)
        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }


      if (text === 'contacts') {
        rows = config.rows
        rows.push({ pref: 'MacBook-Pro-Stas:~ stas$', value: text })
        rows.push({ pref: '→', value: `Telegram: <a style="color: #fff;" href="https://t.me/prohetamine">@prohetamine</a>` })
        rows.push({ pref: '→', value: `Email: <a style="color: #fff;" href="mailto:prohetamine@yandex.ru">prohetamine@yandex.ru</a>` })
        rows.push({ pref: '→', value: `Email: <a style="color: #fff;" href="mailto:prohetamine@gmail.com">prohetamine@gmail.com</a>` })

        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }

      if (oldText === 'contacts') {
        newPref = `MacBook-Pro-Stas:~ stas$`
      }

      if (text === 'rm -rf') {
        rows = config.rows
        rows.push({ pref: 'MacBook-Pro-Stas:~ stas$', value: text })
        newPref = `Continue? (y/N):`

        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }

      if (config.newPref === `Continue? (y/N):` && oldText === 'rm -rf') {
        if (text === 'y' || text === 'Y') {
          newPref = `exit`
          window.document.write(`<!DOCTYPE html><html lang="ru"><head></head><body style='margin: 0px; background-image: url(${blueScreen}); background-size: cover; background-color: #0001fe; width: 100vw; height: 100vh;' onClick='window.location.reload()'></body></html>`)
        } else {
          rows.push({ pref: 'Continue? (y/N):', value: text })
          newPref = `MacBook-Pro-Stas:~ stas$`
        }

        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }

      if (text.match(/^message /) && text.match(/(-n|--name) "[^"]+"/) && text.match(/(-t|--text) "[^"]+"/)) {
        rows = config.rows
        rows.push({ pref: 'MacBook-Pro-Stas:~ stas$', value: text })
        newPref = `Continue? (y/N):`

        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }

      if (config.newPref === `Continue? (y/N):` && oldText.match(/^message /) && oldText.match(/(-n|--name) "[^"]+"/) && oldText.match(/(-t|--text) "[^"]+"/)) {
        if (text === 'y' || text === 'Y') {
          createMessage(oldText)
          rows.push({ pref: 'Continue? (y/N):', value: text })
          rows.push({ pref: 'Your message sended. I got your message!', value: '' })
          newPref = `MacBook-Pro-Stas:~ stas$`
        } else {
          rows.push({ pref: 'Continue? (y/N):', value: text })
          newPref = `MacBook-Pro-Stas:~ stas$`
        }

        return ({
          rows,
          oldText: text,
          text: '',
          newPref
        })
      }

      if (text.length > 0) {
        return ({
          rows: [...rows, { pref: 'MacBook-Pro-Stas:~ stas$', value: text }, { pref: 'bash: ', value: text + ': command not found' }],
          oldText: text,
          text: '',
          newPref
        })
      }

      return ({
        rows: [...rows, { pref: 'MacBook-Pro-Stas:~ stas$', value: text }],
        oldText: text,
        text: '',
        newPref
      })
    })
  }

  return (
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <motion.div
          className={styles.defaultConsole + ' pink-text-selected'}
          style={{ position: 'absolute', height: '100%' }}
          initial={{ scale: 1 }}
          animate={isClose ? { x: 0 } : { x: -5000 }}
          transition={{ duration: 0.5 }}
        >
          <div className={styles.circle} onClick={() => setClose(false)} style={{ background: '#FC5B57', left: '12px' }} />
          <div className={styles.circle} style={{ background: '#E5BF3C', left: '32px' }} />
          <div className={styles.circle} style={{ background: '#57C038', left: '52px' }} />
          <div className={styles.formBody}>
            <input
              value={form.name}
              onChange={({ target: { value } }) => setForm(f => ({ ...f, name: value }))}
              className={styles.formInput + ' pink-text-selected'}
              type='text'
              placeholder='Ваше имя'
            />
            <input
              value={form.contacts}
              onChange={({ target: { value } }) => setForm(f => ({ ...f, contacts: value }))}
              className={styles.formInput + ' pink-text-selected'}
              type='text'
              placeholder='Ваш контакт/телефон/почта/мессенджер..'
            />
            <textarea
              value={form.message}
              onChange={({ target: { value } }) => setForm(f => ({ ...f, message: value }))}
              className={styles.formMessage + ' pink-text-selected'}
              placeholder='Не большое сообщение, предложения или что-то еще.. а лучше сразу писать в телеграм: @prohetamine'
            />
            <div
              className={styles.formSubmit + ' pink-text-selected'}
              onClick={() => {
                const message = form.name+':'+form.contacts+':'+form.message
                message.length > 5 && sendMessageMe(message)
                setForm({
                  name: '',
                  contacts: '',
                  message: ''
                })
              }}
            >
              Отправить
            </div>
          </div>
        </motion.div>
        <motion.div
          className={styles.console + ' console-text-selected'}
          style={{
            backgroundImage: `url(${frog})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
          ref={refSelectConsole}
          initial={{ scale: 1 }}
          animate={isClose ? { x: 5000 } : { x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className={styles.circle} onClick={() => setClose(true)} style={{ background: '#FC5B57', left: '12px' }} />
          <div className={styles.circle} style={{ background: '#E5BF3C', left: '32px' }} />
          <div className={styles.circle} style={{ background: '#57C038', left: '52px' }} />
          <div
            className={styles.darkBackground}
            style={{ top: '0px' }}
          />
        <div className={styles.overflow} ref={refScroll}>
            {
              config.rows.map((row, key) =>
                <div
                  className={styles.textRow + ' console-text-selected'}
                  key={key}
                  dangerouslySetInnerHTML={{ __html: row.pref + `<span style='margin-left: 7px;'></span>` + row.value + `<span style='margin-left: 13px;'></span>` }}
                />
              )
            }
            <div className={styles.textRow} name='text' style={{ width: '100%' }}>
              <span
                className='console-text-selected'
                style={{
                  minWidth: 'fit-content',
                  marginRight: '7px'
                }}
              >
              {config.newPref}
              </span>
              <input
                className={styles.input + ' console-text-selected'}
                type='text'
                ref={refInput}
                onKeyDown={({ keyCode }) => {
                  if (keyCode === 13) {
                    handleEnter()
                  }
                }}
                onChange={({ target: { value } }) => setConfig(config => ({ ...config, text: value }))}
                value={config.text}
              />
            </div>
          </div>
          <div
            className={styles.darkBackground}
            style={{ bottom: '0px' }}
          />
        </motion.div>
      </div>
    </div>
  )
})

export default ContactsConsole
